



































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ToggleButton from "../../../common/vue-toggle-btn/toggle-btn.vue";
import SearchInput from "../../common/search-input/SearchInput.vue";
import {ParticipantsFiltersAvailability} from "@share/participants-table/types/ParticipantsFiltersAvailability";

@Component({
    components: { ToggleButton, SearchInput }
})
export default class ParticipantsTableSearch extends Vue {

    @Prop() value: string;
    @Prop() searchPlaceholder: string;
    @Prop() showSearch: boolean;
    @Prop() showSearchInput: boolean;
    @Prop() onlineOnly: boolean;
    @Prop({ default: true }) showToggles: boolean;
    @Prop({default: () => {return {}}}) filtersAvailability: ParticipantsFiltersAvailability | null;

    toggleOptions = {
        handle: {
            diameter: 17,
            distance: 40
        },
        track : {
            activeColor: "#4CD964",
            width: 32,
            height: 19
        }
    }

    onSearchInput(data: string) {
        this.$emit('input', data);
    }

    clearInput() {
        this.$emit('clearinput');
    }
}
